import React, { Component, useState, useEffect } from 'react'
import Select from 'react-select'
import { ApiAdapter } from "./adapters";
import { useTranslation } from "react-i18next";

import {
  collapseTextChangeRangesAcrossMultipleVersions,
  isConstructorDeclaration,
} from "typescript";


const InviteAlternateContacts: React.FC<any> = ({ my_propa }) => {

  var newApi = (my_propa != undefined) ? my_propa : new ApiAdapter();
  var use_api = (my_propa != undefined) ? false : true;
  var [my_prop, set_prop] = useState(my_propa);
  const [api] = useState(newApi);

  const [selectedOptions, setSelected] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("result", reloadApi);
  });

  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("reset", reset);
  }, [selectedOptions])
  const reset = () => {
    setSelected([]);

  }


  const resetSlection = () => {
    setSelected([]);
  }

  useEffect(() => {

    updateWindow()
  }, [selectedOptions]);

  const updateWindow = () => {
    window["update_preview"]()
  }


  const reloadApi = () => {
    if (use_api) {
      api
        .loadAltContacts()
        .then((resp) => {
          set_prop(resp)
        })
        .catch((errors) => console.log("index errors:", errors));

    }
  }
 const mynoOptionsMessage=(inputValue) => {
    return t("views.show_patient.video_call_invitation.drop_down.contact");
  }
  const onChange = selectedOptions => {
    if (selectedOptions == undefined){
      selectedOptions = []
    }
    setSelected(selectedOptions);
    window["update_preview"]();
  }


  return (
    <div>
      <Select
        value={selectedOptions}
        isMulti
        placeholder={t("views.show_patient.video_call_invitation.drop_down.select_contact")}
        noOptionsMessage={mynoOptionsMessage}
        options={my_prop}
        onChange={onChange}
        name="alternate_contacts"
        className="basic-multi-select"
        classNamePrefix="select"
      />
      {selectedOptions.map((item, i) =>
        <input key={item.value} type="hidden" contact_name={item.label} value={item.value} data_name="alt_contact_id" className="invited-alt-contact custom-control-input" id="alt_contact" />
      )}

    </div>
  );
}

export default InviteAlternateContacts;